import React from 'react'

// next components

import { useRouter } from 'next/router'

// third party components
import { useDispatch } from 'react-redux'

import FosterLogoMobile from 'assets/logo-21x25.svg?component'
import ResourceIcon from 'assets/icons/resource-icon.svg?component'
import TermsIcon from 'assets/icons/terms-icon.svg?component'
import GovernanceIcon from 'assets/icons/governance-icon.svg?component'
import InstagramLightGreenIcon from 'assets/icons/instagram-light-green.svg?component'
import DiscordLightGreenIcon from 'assets/icons/discord-light-green.svg?component'
import TwitterLightGreenIcon from 'assets/icons/twitter-light-green.svg?component'
import GithubLightGreenIcon from 'assets/icons/github-light-green.svg?component'

// styles
import styles from './index.module.scss'
import IconButtonWithSVG from 'components/Button/IconButtonWithSVG'

const AccordionMenu = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  return (
    <div className="w-full">
      <div className={styles.menuItem}>
        <a target="_blank" href="https://about.fostermarketplace.app/" rel="noopener noreferrer" className="w-full">
          <div className="w-full flex items-center">
            <div className={styles.icon}>
              <div className="flex items-center">
                <FosterLogoMobile />
              </div>
            </div>
            <div className="ml-[15px]">
              <div className={styles.title}>About</div>
              <div className={styles.subtitle}>Learn more about the team and vision</div>
            </div>
          </div>
        </a>
      </div>
      <div className={styles.menuItem}>
        <div
          className="w-full flex items-center"
          onClick={() => {
            dispatch({ type: 'set', openMobileMenu: false })
            router.push('/dao')
          }}
        >
          <div className={styles.icon}>
            <div className="flex items-center">
              <GovernanceIcon />
            </div>
          </div>
          <div className="ml-[15px]">
            <div className={styles.title}>Governance</div>
            <div className={styles.subtitle}>Submit and vote on protocol proposals</div>
          </div>
        </div>
      </div>
      <div className={styles.menuItem}>
        <div
          className="w-full flex items-center"
          onClick={() => {
            dispatch({ type: 'set', openMobileMenu: false })
            router.push('/resources')
          }}
        >
          <div className={styles.icon}>
            <div className="flex items-center">
              <ResourceIcon />
            </div>
          </div>
          <div className="ml-[15px]">
            <div className={styles.title}>Resources</div>
            <div className={styles.subtitle}>User guides and tutorials</div>
          </div>
        </div>
      </div>
      <div className="w-full h-[75px] flex justify-center items-center">
        <a target="_blank" href={process.env.NEXT_PUBLIC_TERMS_OF_USE} rel="noopener noreferrer" className="w-full">
          <div className="w-full flex items-center">
            <div className={styles.icon}>
              <div className="flex items-center">
                <TermsIcon />
              </div>
            </div>
            <div className="ml-[15px]">
              <div className={styles.title}>Terms of Service</div>
              <div className={styles.subtitle}>Terms of use, privacy policy, etc.</div>
            </div>
          </div>
        </a>
      </div>
      <div className="w-full flex justify-center mt-[78px] mb-[42px]">
        <div className={styles.border} />
      </div>
      <div className={styles.allRights}>2025 Foster © All Rights Reserved</div>
      <div className="flex mt-[15px] gap-[18px] justify-center mb-[100px]">
        <div>
          <a target="_blank" href={process.env.NEXT_PUBLIC_INSTAGRAM_URL} rel="noopener noreferrer">
            <IconButtonWithSVG
              backgroundColor="var(--social-bg-color)"
              icon={<InstagramLightGreenIcon />}
              onClick={() => {}}
            />
          </a>
        </div>
        <div>
          <a target="_blank" href={process.env.NEXT_PUBLIC_DISCORD_URL} rel="noopener noreferrer">
            <IconButtonWithSVG
              backgroundColor="var(--social-bg-color)"
              icon={<DiscordLightGreenIcon />}
              onClick={() => {}}
            />
          </a>
        </div>
        <div>
          <a target="_blank" href={process.env.NEXT_PUBLIC_TWITTER_URL} rel="noopener noreferrer">
            <IconButtonWithSVG
              backgroundColor="var(--social-bg-color)"
              icon={<TwitterLightGreenIcon />}
              onClick={() => {}}
            />
          </a>
        </div>
        <div>
          <a target="_blank" href={process.env.NEXT_PUBLIC_GITHUB_URL} rel="noopener noreferrer">
            <IconButtonWithSVG
              backgroundColor="var(--social-bg-color)"
              icon={<GithubLightGreenIcon />}
              onClick={() => {}}
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default AccordionMenu
